import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { parseAudience } from './-components/contact/audiences';

/**
 * The audience page, and the parent of the one tab that has a URL of its own. It renders no UI at all:
 * the questionnaire is the shell's (see `contact.tsx`), which is what keeps switching audience — or
 * tab — from remounting the page around it. Its children contribute only their own head.
 */
export const Route = createFileRoute('/new/contact/$audience')({
	// In `beforeLoad`, so a segment naming no audience is a 404 before anything renders. The parent's
	// `parseAudience` would already answer null and draw the chooser, and answering 200 with a page at
	// an invented URL is the soft 404 `/new/$` exists to avoid.
	beforeLoad: ({ params }) => {
		if (!parseAudience(params.audience)) throw notFound();
	},
	component: Outlet,
});
